import NewsLetterSubscriptionForm from './NewsLetterSubscriptionForm';

export default NewsLetterSubscriptionForm;
